export type CalendarJobTypeLeftColumnLabel =
  | { variant: 'own-company'; branchOfficeName: string; departmentName: string }
  | { variant: 'other-company'; companyName: string };

type CalendarPlanningDepartmentLabelSource = {
  companyName: string;
  name: string;
  branchOffice: { name: string };
};

export const getCalendarJobTypeLeftColumnLabel = (
  department: CalendarPlanningDepartmentLabelSource,
  ownCompanyName: string
): CalendarJobTypeLeftColumnLabel => {
  if (department.companyName === ownCompanyName) {
    return {
      variant: 'own-company',
      branchOfficeName: department.branchOffice.name,
      departmentName: department.name,
    };
  }

  return {
    variant: 'other-company',
    companyName: department.companyName,
  };
};

export const getCalendarJobTypeLeftColumnTitle = (
  label: CalendarJobTypeLeftColumnLabel,
  jobTypeName: string
): string => {
  const headerLine =
    label.variant === 'own-company'
      ? `${label.branchOfficeName}-${label.departmentName}`
      : label.companyName;

  return `${headerLine}\n${jobTypeName}`;
};
